import { motion } from "motion/react";
import React, { useReducer, useState } from "react";
import dayjs from "dayjs";

export interface WeeklyCalendarDragAndDropCellDragEndHandlerArgs {
  source: {
    getCell: <T>(dates: Record<string, T[]>) => T;
    dateStr: string;
    getColumn: <T>(dates: Record<string, T[]>) => T[];
  };
  target: {
    dateStr: string;
    getColumn: <T>(dates: Record<string, T[]>) => T[];
  };
  cancel: () => void;
}

export type WeeklyCalendarDragAndDropCellDragEndHandler = (
  args: WeeklyCalendarDragAndDropCellDragEndHandlerArgs,
) => void;

export interface WeeklyCalendarDragAndDropCellProps {
  children: React.ReactNode;
  calendarCellWidth: number;
  onDragEnd: WeeklyCalendarDragAndDropCellDragEndHandler;
  date?: Date;
  dateStr?: string;
  index?: number;
}

export const WeeklyCalendarDragAndDropCell = ({
  children,
  onDragEnd,
  date,
  dateStr,
  index,
  calendarCellWidth,
}: WeeklyCalendarDragAndDropCellProps) => {
  const [flag, cancel] = useReducer((prev) => !prev, false);
  const [dragging, setDragging] = useState(false);
  if (date === undefined || dateStr === undefined || index === undefined) {
    return null;
  }
  return (
    <motion.div
      style={{
        cursor: dragging ? "grabbing" : "grab",
      }}
      key={`${flag}`}
      drag
      dragMomentum={false}
      onDragStart={() => {
        setDragging(true);
      }}
      onDragEnd={(_, info) => {
        setDragging(false);

        const deltaX = Math.round(info.offset.x / calendarCellWidth);
        if (deltaX === 0) {
          cancel();
          return;
        }
        const targetDateStr = dayjs(date).add(deltaX, "day").format("YYYYMMDD");
        onDragEnd({
          cancel,
          source: {
            getCell: (dates) => {
              return dates[dateStr][index];
            },
            dateStr: dateStr,
            getColumn: (dates) => {
              const sourceColumn = dates[dateStr].slice();
              sourceColumn.splice(index, 1);
              return sourceColumn;
            },
          },
          target: {
            dateStr: targetDateStr,
            getColumn: (dates) => {
              const targetColumn = dates[targetDateStr].slice();
              const content = dates[dateStr][index];
              targetColumn.unshift(content);
              return targetColumn;
            },
          },
        });
      }}
    >
      {children}
    </motion.div>
  );
};
